import LinkButton from './link-button';
import { LinkButtonTypes } from './types';

import './link-button.css';

export default function LinkPseudoButton({
  className,
  text = '',
  disabled,
  icon,
  onClick,
  path,
}: LinkButtonTypes): React.JSX.Element {
  return (
    <LinkButton
      path={path}
      className={`${className || ''} pseudo`}
      text={text}
      disabled={disabled}
      icon={icon}
      onClick={onClick}
    />
  );
}
